import { Box, Button, Grid, Link, Typography } from '@mui/material';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { OTPContainer } from './components/OTPContainer';
import TestimonialsCarousel from './components/TestimonialsCarousel';

export const ConfirmPhoneCodeOnboarding = () => {
  const navigate = useNavigate();
  const inputRefs = useRef<Array<any>>([]);

  const handleInputChange = (index: number, event: any) => {
    const value = event.target.value;
    if (value.length > 1) {
      event.target.value = value.slice(0, 1);
      return;
    }
    if (value.length === 1 && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleGoToNextPage = () => {
    navigate('/onboarding/v2/confirm-informations');
  };

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#19191C',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 750,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
          }}
        >
          <img
            src="/icon/artwork.svg"
            alt=""
            style={{
              width: 180,
              height: 'auto',
              marginBottom: 0,
            }}
          />
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="h6"
            fontWeight={400}
            fontSize={16}
            mb={5}
            mt={1}
            align="center"
            sx={{ width: '100%' }}
          >
            Sign in to Oppy dashboard
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            variant="subtitle1"
            fontWeight={400}
            mb={2}
            align="center"
            sx={{ width: '100%' }}
          >
            Verification code sent to +1 123 123 1234{' '}
            <Link href="#" variant="body2" color="#4949C8" underline="hover">
              change
            </Link>
          </Typography>
          <OTPContainer
            length={6}
            onChange={(value) => console.log('OTP value:', value)}
            onComplete={(value) => console.log('OTP complete:', value)}
          />
          {/* Resend code como button, menor e próximo dos inputs */}
          <Box sx={{ width: '100%', maxWidth: 380, textAlign: 'left', mb: 1 }}>
            <Button
              onClick={() => console.log('Resend code clicked')}
              sx={{
                fontSize: 16,
                fontWeight: 400,
                color: '#4949C8',
                textTransform: 'none',
                padding: 0,
                outline: 'none',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                  backgroundColor: 'transparent',
                },
              }}
            >
              Resend code
            </Button>
          </Box>

          <Button
            onClick={() => console.log('Resend code clicked')}
            sx={{
              mt: 2,
              padding: 0,
              fontSize: 16,
              fontWeight: 400,
              color: '#4949C8',
              outline: 'none',
              textTransform: 'none',
              textDecoration: 'none',
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
              },
            }}
          >
            Sign in usign email
          </Button>
          <Typography variant="body2" mt={4} textAlign="center" color="#fff">
            Don't have an account yet?{' '}
            <Link href="#" color="#4949C8" underline="hover">
              Start a free trial
            </Link>
          </Typography>
        </Box>
      </Grid>
      {/* Direita: Marketing/Testimonials */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 600, textAlign: 'center', mb: 0 }}>
          <Typography
            variant="h5"
            fontFamily="Space Grotesk"
            fontWeight={700}
            color="#4949C8"
            sx={{ mb: 1 }}
          >
            Oppy's AI assistants handle <br /> your daily tasks…
          </Typography>
          <Typography variant="subtitle1" color="#222" sx={{ mb: 4 }}>
            so you can focus on showing homes, closing <br /> deals, and
            building relationships.
          </Typography>
        </Box>
        <TestimonialsCarousel />
      </Grid>
    </Grid>
  );
};
